import _classCallCheck from "/builds/thema-developers/nuovo-osix-configurator-usa/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/thema-developers/nuovo-osix-configurator-usa/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/thema-developers/nuovo-osix-configurator-usa/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/thema-developers/nuovo-osix-configurator-usa/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.parse-float.js";
import { __decorate } from "tslib";
import Component from "vue-class-component";
import Vue from "vue";
import { Watch } from "vue-property-decorator";
import MatImage from "./MatImage.vue"; // import { Color } from "configurator-base-app/dist/libModules/Colors";

var Aste = /*#__PURE__*/function (_Vue) {
  _inherits(Aste, _Vue);

  var _super = _createSuper(Aste);

  function Aste() {
    var _this;

    _classCallCheck(this, Aste);

    _this = _super.apply(this, arguments); // Variabile utilizzata per mostrare il un dialog di warning all'utente quando cambia materiale avendo definito personalizzazioni

    _this.sicuroCambioMateriale = false; // Materiale selezionato dall'utente nel filtro

    _this.matFiltro = _this.templesColor && _this.templesColor.METALTEMPLE == "1" ? "MT" : "PL";
    _this.findTempleColor = "";
    _this.activeTemple = _this.templesColor ? _this.templesColor : null; // Ricorda il materiale che l'utente vuole selezionare quando mostri il dialog "Sicuro di voler cambiare materiale?"

    _this.materialToChange = null; // Ricorda le aste che l'utente vuole selezionare quando mostri il dialog "Sicuro di voler cambiare materiale?"

    _this.templeToActivate = null;
    return _this;
  }

  _createClass(Aste, [{
    key: "temples",
    get: function get() {
      var _this2 = this;

      if (this.$store.state.affogatiEnabled) {
        var height = this.getLastNumberFromString(this.frontale.ModelName);

        var _aste = this.$store.state.mappedTempleColors.get(height).filter(function (a) {
          return _this2.finituraFrontale == "N" ? a.U_THE_FINITURA == _this2.finituraFrontale : a.U_THE_FINITURA != "N";
        });

        if (this.finituraFrontale == "N") {
          this.$store.state.cachedAsteAffogatiNaturali = _aste;
        } else {
          this.$store.state.cachedAsteAffogatiLucide = _aste;
        }

        return _aste;
      }

      if (this.$store.state.cachedAsteNonAffogati.length > 0) {
        return this.$store.state.cachedAsteNonAffogati;
      }

      var aste = this.$store.state.configurator.aste.allColors.filter(function (a) {
        var _a$U_THE_MODELLO, _a$U_THE_MODELLO2;

        return !((_a$U_THE_MODELLO = a.U_THE_MODELLO) !== null && _a$U_THE_MODELLO !== void 0 && _a$U_THE_MODELLO.includes("7.5F")) && !((_a$U_THE_MODELLO2 = a.U_THE_MODELLO) !== null && _a$U_THE_MODELLO2 !== void 0 && _a$U_THE_MODELLO2.includes("12F"));
      });
      this.$store.state.cachedAsteNonAffogati = aste;
      return aste;
    }
  }, {
    key: "tipoAbbellitore",
    get: function get() {
      return this.$store.state.configurator.abbellitore == null ? "A" : "B";
    },
    set: function set(newV) {
      if (this.currentSubline == "OVBOLDUS") {
        this.$store.commit("configurator/setAbbellitore", newV == 'A' ? null : "PRO0002044");
      } else {
        this.$store.commit("configurator/setAbbellitore", newV == 'A' ? null : !this.coloreMetalloAste || this.coloreMetalloAste == "PRO0000272" ? "PRO0000849" : "PRO0000850");
      }
    }
  }, {
    key: "materialePerFiltro",
    get: function get() {
      if (this.currentSubline == "OVBOLDUS") return "PL";
      return this.matFiltro;
    },
    set: function set(m) {
      this.matFiltro = m; // Aggiorno variabile
      // Controllo se la configurazione è valida

      var at = this.activeTemple;
      var a = [];

      if (at != null) {
        a = this.temples.filter(function (t) {
          var mat = m == "PL" ? "0" : "1";
          return (at === null || at === void 0 ? void 0 : at.U_THE_COLORE) == t.U_THE_COLORE && (at === null || at === void 0 ? void 0 : at.U_THE_LUNGASTA) == t.U_THE_LUNGASTA && t.METALTEMPLE == mat;
        });
      } // Se la configurazione è valida


      if (a.length > 0) {
        if (this.matFiltro == "MT" && this.presentiPersonalizzazioniAste) {
          // Se ho personalizzazioni attive ed il materiale del filtro è Metallo, chiedo all'utente se è sicuro di voler cambiare materiale ed eliminare le personalizzazioni sulle aste
          this.materialToChange = m;
          this.templeToActivate = a[0];
          this.sicuroCambioMateriale = true;
        } else {
          // Altrimenti setto definitivamente il materiale selezionato
          this.setTemplesMaterial(m);
          this.setActiveTemple(a[0]);
        }
      } // Se la configurazione non è valida, mantengo la variabile matFiltro per
      // - eseguire il filtraggio dei colori
      // - settare il materiale giusto quando l'utente sceglierà un colore valido per il materiale selezionato

    }
  }, {
    key: "sizesAvailables",
    get: function get() {
      var availableSizes = [];

      for (var i = 0; i < this.temples.length; i++) {
        if (this.materialePerFiltro == "PL") {
          if (this.temples[i].METALTEMPLE == 0 && availableSizes.indexOf(this.temples[i].U_THE_LUNGASTA) < 0) {
            if (this.currentSubline == "OVBOLDUS" && this.temples[i].U_THE_SOTTOLINEA == "OVBOLDUS") {
              availableSizes.push(this.temples[i].U_THE_LUNGASTA);
            } else if (this.currentSubline != "OVBOLDUS" && this.temples[i].U_THE_SOTTOLINEA != "OVBOLDUS") {
              availableSizes.push(this.temples[i].U_THE_LUNGASTA);
            }
          }
        } else {
          if (this.temples[i].METALTEMPLE == 1 && availableSizes.indexOf(this.temples[i].U_THE_LUNGASTA) < 0) {
            if (this.currentSubline == "OVBOLDUS" && this.temples[i].U_THE_SOTTOLINEA == "OVBOLDUS") {
              availableSizes.push(this.temples[i].U_THE_LUNGASTA);
            } else if (this.currentSubline != "OVBOLDUS" && this.temples[i].U_THE_SOTTOLINEA != "OVBOLDUS") {
              availableSizes.push(this.temples[i].U_THE_LUNGASTA);
            }
          }
        }
      }

      return availableSizes;
    }
  }, {
    key: "currentSubline",
    get: function get() {
      var _this$$store$state$co;

      return (_this$$store$state$co = this.$store.state.configurator.frontale) === null || _this$$store$state$co === void 0 ? void 0 : _this$$store$state$co.U_THE_SOTTOLINEA;
    }
  }, {
    key: "filteredTemples",
    get: function get() {
      var _this3 = this;

      var result = this.temples;
      var q = this.findTempleColor;

      if (q) {
        result = result.filter(function (t) {
          // return _.includes(t.U_THE_COLORE, q);
          return t.U_THE_COLORE.indexOf(q) > -1;
        });
      }

      if (this.materialePerFiltro) {
        result = result.filter(function (t) {
          if (_this3.materialePerFiltro == "PL") {
            return t.METALTEMPLE == "0";
          } else {
            return t.METALTEMPLE == "1";
          } //return t.materiale == this.materiale

        });
      }

      if (this.misuraAste) {
        result = result.filter(function (t) {
          return t.U_THE_LUNGASTA == _this3.misuraAste;
        });
      }

      result = result.filter(function (t) {
        return _this3.currentSubline == "OVBOLDUS" ? t.U_THE_SOTTOLINEA == "OVBOLDUS" : t.U_THE_SOTTOLINEA != "OVBOLDUS";
      });
      return result;
    }
  }, {
    key: "frontale",
    get: function get() {
      return this.$store.state.configurator.frontale;
    }
  }, {
    key: "finituraFrontale",
    get: function get() {
      return this.$store.state.configurator.finitura;
    }
  }, {
    key: "templesColor",
    get: function get() {
      return this.$store.state.configurator.coloreAste;
    }
  }, {
    key: "misuraAste",
    get: function get() {
      return this.$store.state.configurator.misuraAste;
    },
    set: function set(ma) {
      this.$store.commit("configurator/setTemplesSize", ma);
    }
  }, {
    key: "finituraAste",
    get: function get() {
      return this.$store.state.configurator.finituraAste;
    },
    set: function set(fa) {
      this.$store.commit("configurator/setTemplesFinishing", fa);
    }
  }, {
    key: "materiale",
    get: function get() {
      return this.$store.state.configurator.templesMaterial;
    },
    set: function set(m) {
      this.$store.commit("configurator/setTemplesMaterial", m);
    }
  }, {
    key: "coloreMetalloAste",
    get: function get() {
      return this.$store.state.configurator.coloreMetalloAste;
    },
    set: function set(c) {
      if (this.materiale == "MT") {
        this.$store.commit("configurator/setTemplesMetalColor", c);
      }

      if (this.tipoAbbellitore != "A") {
        this.$store.commit("configurator/setAbbellitore", c == "PRO0000272" ? "PRO0000849" : "PRO0000850");
      }
    }
  }, {
    key: "presentiPersonalizzazioniAste",
    get: function get() {
      return this.$store.state.configurator.aste.extSxName != "" || this.$store.state.configurator.aste.extSxNameColor != null || this.$store.state.configurator.aste.intSxName != "" || this.$store.state.configurator.aste.intSxNameColor != null || this.$store.state.configurator.aste.extDxName != "" || this.$store.state.configurator.aste.extDxNameColor != null || this.$store.state.configurator.aste.intDxName != "" || this.$store.state.configurator.aste.intDxNameColor != null;
    } // noTempleAvailable() {
    //   if (this.filteredTemples.length == 0) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }

  }, {
    key: "setTemplesColor",
    value: function setTemplesColor(t) {
      this.$store.commit("configurator/setTemplesColor", t);
    }
  }, {
    key: "setTemplesMaterial",
    value: function setTemplesMaterial(tm) {
      this.$store.commit("configurator/setTemplesMaterial", tm);
    }
  }, {
    key: "unsetTemplesMetalColor",
    value: function unsetTemplesMetalColor() {
      this.$store.commit("configurator/unsetTemplesMetalColor");
    }
  }, {
    key: "resetPersonalizzazioniAste",
    value: function resetPersonalizzazioniAste() {
      this.$store.commit("resetPersonalizzazioniAste");
    }
  }, {
    key: "getLastNumberFromString",
    value: function getLastNumberFromString(inputString) {
      // Define a regular expression pattern to match numbers at the end of the string
      var pattern = /(\d{1,3}(?:[.,]\d{3})*(?:[.,]\d+)?)(?=\D*$|$)/; // Use the match method to find the number

      var match = inputString.match(pattern); // Check if a match was found

      if (match) {
        // Extract the matched number and replace commas with periods
        var matchedNumber = match[0].replace(",", "."); // Parse the number as a float

        var parsedNumber = parseFloat(matchedNumber);
        return parsedNumber;
      } // If no match was found, return NaN or handle it as needed


      return NaN;
    }
    /**
     * Verifica se bisogna chiedere all'utente conferma nel caso stia selezionando metallo mentre ha personalizzazioni attive sulle aste
     */

  }, {
    key: "tryActivateTemple",
    value: function tryActivateTemple(t) {
      if (this.matFiltro == "MT" && this.presentiPersonalizzazioniAste) {
        this.materialToChange = this.materiale;
        this.templeToActivate = t;
        this.sicuroCambioMateriale = true;
      } else {
        this.setActiveTemple(t);
      }
    }
  }, {
    key: "setActiveTemple",
    value: function setActiveTemple(t) {
      this.activeTemple = t;
      this.setTemplesColor(t);

      if (t.U_THE_LUNGASTA != this.misuraAste) {
        this.misuraAste = t.U_THE_LUNGASTA;
      }
    }
  }, {
    key: "canShowMetalColors",
    value: function canShowMetalColors() {
      return (this.templesColor && this.templesColor.METALTEMPLE == "1") == 1;
    }
  }, {
    key: "materialChanged",
    value: function materialChanged(newVal) {
      var at = this.activeTemple;
      var a = [];

      if (at != null) {
        a = this.temples.filter(function (t) {
          var m = newVal == "PL" ? 0 : 1;
          return (at === null || at === void 0 ? void 0 : at.U_THE_COLORE) == t.U_THE_COLORE && (at === null || at === void 0 ? void 0 : at.U_THE_LUNGASTA) == t.U_THE_LUNGASTA && t.METALTEMPLE == m;
        });
      }

      if (a.length > 0) {
        this.tryActivateTemple(a[0]);
      }

      if (newVal == "PL") {
        this.unsetTemplesMetalColor();
      } else if (newVal == "MT") {
        this.coloreMetalloAste = this.coloreMetalloAste == null ? "PRO0000272" : this.coloreMetalloAste; //this.coloreMetalloAste = 'PRO0000272';
      }
    }
  }, {
    key: "misuraAsteChanged",
    value: function misuraAsteChanged(newVal) {
      var _this4 = this;

      /*
          se ho un'asta attiva e cambia la misura
          sostituisco all'asta attiva una con
          stesso colore, stesso materiale e misura selezionata
        */
      var at = this.activeTemple;

      if (at != null) {
        var a = this.temples.filter(function (t) {
          return t.U_THE_COLORE == (at === null || at === void 0 ? void 0 : at.U_THE_COLORE) && t.METALTEMPLE == (at === null || at === void 0 ? void 0 : at.METALTEMPLE) && t.U_THE_LUNGASTA == newVal && (_this4.currentSubline == "OVBOLDUS" ? t.U_THE_SOTTOLINEA == "OVBOLDUS" : t.U_THE_SOTTOLINEA != "OVBOLDUS");
        });

        if (a.length > 0) {
          this.setActiveTemple(a[0]); // } else {
          //   this.noTempleAvailable = true;
        }
      }
    }
  }, {
    key: "activeTempleChanged",
    value: function activeTempleChanged() {
      return this.setTemplesMaterial(this.materiale);
    }
  }, {
    key: "templesColorChanged",
    value: function templesColorChanged(newVal, oldVal) {
      if (oldVal) {
        if (newVal.U_THE_COLORE != oldVal.U_THE_COLORE) {
          this.activeTemple = newVal; // Ora che l'utente ha selezionato un colore valido, setto il materiale corrispondente al tab in cui si trova

          this.materiale = this.materialePerFiltro;
        }
      }
    }
  }]);

  return Aste;
}(Vue);

__decorate([Watch("materiale")], Aste.prototype, "materialChanged", null);

__decorate([Watch("misuraAste")], Aste.prototype, "misuraAsteChanged", null);

__decorate([Watch("activeTemple")], Aste.prototype, "activeTempleChanged", null);

__decorate([Watch("templesColor")], Aste.prototype, "templesColorChanged", null);

Aste = __decorate([Component({
  components: {
    MatImage: MatImage
  }
})], Aste);
export default Aste;